module.exports = "svg.app-icons{fill:currentColor;vertical-align:text-bottom}\n"